<template>
  <div>
    <px-view-header title="Vendas do catálogo" :breadcrumbs="breadcrumbs"/>

    <px-selecao-mes @change="onChangeData"/>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading && totalizadores">
      <div>
        <v-row>
          <v-col cols="12" sm="6">
            <v-hover v-slot:default="{ hover }" open-delay="100">
              <px-indicador-card :elevation="hover ? 12 : 2"
                                 :value="totalComprado"
                                 color="success"
                                 description="valor vendido"
                                 icon="mdi-currency-usd"/>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6">
            <v-hover v-slot:default="{ hover }" open-delay="100">
              <px-indicador-card :elevation="hover ? 12 : 2"
                                 :value="totalCompras"
                                 color="blue"
                                 description="vendas"
                                 icon="mdi-shopping"/>
            </v-hover>
          </v-col>
        </v-row>
      </div>

      <div v-if="selectedDate">
        <px-indicadores-catalogo-listagem-vendas :data-mes="selectedDate"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VendasListagemService from '@/modules/vendas/vendas-service';
import IndicadoresCatalogoListagemVendas from './IndicadoresCatalogoListagemVendas.vue';

export default {
  data() {
    return {
      loading: false,
      selectedDate: null,
      totalizadores: null,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Vendas do catálogo' },
      ],
    };
  },
  computed: {
    query() {
      return `origemCompra = "CATALOGO_COMPRA_CONJUNTA" and dataCompra >= ${this.selectedDate.startDate} and dataCompra <= ${this.selectedDate.endDate} and situacao in ("PENDENTE_COMPRADOR", "PENDENTE_FORNECEDOR", "APROVADA")`;
    },
    totalComprado() {
      if (!this.totalizadores) {
        return Vue.filter('currency')(0);
      }
      return Vue.filter('currency')(this.totalizadores.total || 0);
    },
    totalCompras() {
      if (!this.totalizadores) {
        return 0;
      }
      return this.totalizadores.quantidade || 0;
    },
  },
  methods: {
    onChangeData(date) {
      this.selectedDate = date;
      this.getTotalizadores();
    },
    getTotalizadores() {
      this.loading = true;
      VendasListagemService.getTotalizadores({
        query: this.query,
      })
        .then(({ data }) => {
          this.totalizadores = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxIndicadoresCatalogoListagemVendas: IndicadoresCatalogoListagemVendas,
  },
};
</script>
